import React, { useCallback, useEffect, useRef, useState } from 'react';

// 🔑 MODUL SIRLARI — parol / API kalit / token.
//
// NEGA: #874 da operator Eskiz kalitini aniqlashtirish javobiga yozishga majbur
// bo'ldi (boshqa kanal yo'q edi) → agent uni kodga yozdi → GitLab main tarixiga
// tushdi. Endi sir shu yerdan kiritiladi: shifrlangan holda saqlanadi, faqat
// `.env` ga quyiladi, AGENT esa faqat NOMINI ko'radi.
//
// Qiymat serverdan HECH QACHON qaytmaydi — ro'yxatda doim `••••••`.

const SCOPE_LABEL = { test: '🧪 test', prod: '🚀 prod', both: '🧪🚀 ikkalasi' };

export default function SecretsCard({ moduleId, authFetch, apiUrl, serverRunning, hasProd }) {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ key: '', value: '', scope: 'both' });
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(false);
  // 🔎 Kalit HAQIQATAN ishlaydimi. Operator: "mijozga tushuntirishlar ortiqcha —
  // Khorezmai o'zi tekshirib, akkauntdagi kamchilikni o'zi to'g'irlasin".
  const [chk, setChk] = useState({});     // {KEY: {loading, ok, verdict, blocked, fixable, ...}}

  // authFetch REF orqali — aks holda har renderda effekt qayta ishga tushadi
  const afRef = useRef(authFetch);
  useEffect(() => { afRef.current = authFetch; }, [authFetch]);

  const load = useCallback(async () => {
    try {
      const r = await afRef.current(`${apiUrl}/project-modules/${moduleId}/secrets`);
      const d = await r.json().catch(() => null);
      if (r.ok && d && Array.isArray(d.secrets)) setRows(d.secrets);
    } catch (e) { /* o'tkinchi xato — ro'yxat saqlanadi */ }
  }, [apiUrl, moduleId]);

  useEffect(() => { load(); }, [load]);

  const save = async () => {
    if (!form.key || !form.value) { setMsg('❌ Nom va qiymat kerak'); return; }
    setBusy(true); setMsg('');
    try {
      const r = await afRef.current(`${apiUrl}/project-modules/${moduleId}/secrets`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.error || `Xato ${r.status}`);
      setMsg(`✅ ${d.key} saqlandi — endi «qo'llash» bilan .env ga yuboring`);
      setForm({ key: '', value: '', scope: form.scope });
      load();
    } catch (e) { setMsg('❌ ' + e.message); }
    finally { setBusy(false); }
  };

  // scope berilsa faqat o'sha qiymat o'chadi (bitta nom test/prod uchun alohida saqlangan bo'lishi mumkin).
  const del = async (key, scope = null) => {
    if (!window.confirm(`${key}${scope ? ` (${SCOPE_LABEL[scope] || scope})` : ''} o'chirilsinmi? (.env dagi qatorni QO'LDA olib tashlaysiz)`)) return;
    try {
      const r = await afRef.current(`${apiUrl}/project-modules/${moduleId}/secrets/${encodeURIComponent(key)}${scope ? `?scope=${encodeURIComponent(scope)}` : ''}`, { method: 'DELETE' });
      if (!r.ok) throw new Error(`Xato ${r.status}`);
      setMsg(`${key} o'chirildi`); load();
    } catch (e) { setMsg('❌ ' + e.message); }
  };

  // fix=false → faqat xulosa; fix=true → Khorezmai konsol orqali o'zi tuzatadi.
  const checkKey = async (name, fix) => {
    setChk(c => ({ ...c, [name]: { ...(c[name] || {}), loading: true } }));
    try {
      const r = await afRef.current(`${apiUrl}/project-modules/${moduleId}/secrets/${encodeURIComponent(name)}/check`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ fix: !!fix }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) { setChk(c => ({ ...c, [name]: { loading: false, error: d.error || `Xato ${r.status}` } })); return; }
      setChk(c => ({ ...c, [name]: { ...d, loading: false } }));
    } catch (e) { setChk(c => ({ ...c, [name]: { loading: false, error: 'Server javob bermadi' } })); }
  };

  const apply = async (target) => {
    if (target === 'prod' && !window.confirm('Sirlar PRODUCTION serverning .env fayliga yoziladi va servis qayta ishga tushiriladi. Davom etamizmi?')) return;
    setBusy(true); setMsg('');
    try {
      const r = await afRef.current(`${apiUrl}/project-modules/${moduleId}/secrets/apply`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ target }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.error || `Xato ${r.status}`);
      const n = (d.keys || []).length;
      setMsg(`✅ ${n} ta kalit ${target === 'prod' ? 'PRODUCTION' : 'test env'} .env ga yozildi: ${(d.keys || []).join(', ')}. `
        + `Servis qayta ishga tushirilmoqda (bir necha daqiqa) — tugagach qiymatlar kuchga kiradi.`);
      load();
    } catch (e) { setMsg('❌ ' + e.message); }
    finally { setBusy(false); }
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-5">
      <div className="flex items-center justify-between mb-1">
        <h3 className="font-semibold text-gray-700 dark:text-gray-300 text-sm">🔑 Sirlar (env)</h3>
        <button onClick={() => setOpen(o => !o)} className="text-xs text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
          {open ? 'yopish' : `${rows.length} ta`}
        </button>
      </div>
      <p className="text-[11px] text-gray-400 mb-3">
        Parol / API kalit shu yerda <b>shifrlangan</b> saqlanadi va faqat <code>.env</code> ga quyiladi.
        Qiymat qaytib ko'rsatilmaydi, <b>AI agent esa faqat nomini ko'radi</b>.
        ✅ = <code>.env</code> ga tushgan, ⏳ = hali qo'llanmagan. Tugmani takror bossangiz
        xavfsiz — qiymat <b>ustiga yoziladi</b>, takrorlanmaydi. Bitta nom test va prod uchun <b>alohida qiymat</b>
        olishi mumkin (masalan PAYME_KEY: test kaliti va haqiqiy kalit) — «faqat test» va «faqat prod» bilan ikki marta saqlang.
      </p>

      {msg && <div className="mb-3 text-xs bg-gray-50 dark:bg-gray-700 border rounded px-3 py-2 break-words">{msg}</div>}

      {rows.length > 0 && (
        <div className="mb-3 divide-y border rounded">
          {rows.map(s => (
            <div key={`${s.key}:${s.scope}`} className="flex items-center gap-2 px-3 py-2">
              <span className="font-mono text-xs text-gray-700 dark:text-gray-300 flex-1 break-all">{s.key}</span>
              <span className="font-mono text-xs text-gray-400">{s.masked}</span>
              <span className="text-[10px] px-1.5 py-0.5 rounded bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400 shrink-0">{SCOPE_LABEL[s.scope] || s.scope}</span>
              {/* .env ga tushdimi? "⏳" = saqlangan, lekin hali qo'llanmagan (yoki
                  qo'llangandan keyin o'zgartirilgan) — operator tugmani takror
                  bosib "tushdimikan?" deb o'ylamasin. */}
              {/* 🔎 .env ✓, lekin konteynerga YETMAGAN (in_container = 0, Navbatchi #26) — compose `environment:` ro'yxatida yo'q:
                  ilova sozlamasiz ishlaydi. Ilgari bu holatda ham «✅ prod» chiqardi (TezHal MYID). */}
              {s.testOk !== null && s.testOk !== undefined && (s.testOk && s.testInContainer === 0 ? (
                <span title="Test .env ga yozildi, lekin test konteyneri bu kalitni KO'RMAYAPTI — test muhitini qayta deploy qiling"
                  className="text-[10px] px-1.5 py-0.5 rounded shrink-0 bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-400 font-semibold">⚠️ test</span>
              ) : (
                <span title={s.testOk ? `Test env .env da bor${s.testInContainer === 1 ? ' · konteyner ichida ham bor' : ''}` : "Test env ga hali qo'llanmagan"}
                  className={`text-[10px] px-1.5 py-0.5 rounded shrink-0 ${s.testOk ? 'bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-400' : 'bg-amber-50 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400'}`}>
                  {s.testOk ? '✅' : '⏳'} test
                </span>
              ))}
              {s.prodOk !== null && s.prodOk !== undefined && (s.prodOk && s.prodInContainer === 0 ? (
                <span title={`Production .env ga yozildi, lekin KONTEYNERGA YETMADI — docker-compose.yml da servis env'ni environment: ro'yxati bilan oladi va ${s.key} unda yo'q. Ro'yxatga «${s.key}: \${${s.key}}» qo'shing (yoki env_file: .env) va qayta ishga tushiring — 🧠 Agent buni ✅ tasdiq bilan qila oladi.`}
                  className="text-[10px] px-1.5 py-0.5 rounded shrink-0 bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-400 font-semibold">⚠️ prod: konteynerda yo'q</span>
              ) : (
                <span title={s.prodOk ? `Production .env da bor${s.prodInContainer === 1 ? ' · konteyner ichida ham bor' : ''}` : "Production ga hali qo'llanmagan"}
                  className={`text-[10px] px-1.5 py-0.5 rounded shrink-0 ${s.prodOk ? 'bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-400' : 'bg-amber-50 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400'}`}>
                  {s.prodOk ? '✅' : '⏳'} prod
                </span>
              ))}
              <button onClick={() => checkKey(s.key, false)} disabled={(chk[s.key] || {}).loading}
                title="Kalit haqiqatan ishlayaptimi — provayderdan so'rab tekshiradi"
                className="text-xs text-gray-400 hover:text-primary-700 dark:hover:text-primary-300 shrink-0 disabled:opacity-40">
                {(chk[s.key] || {}).loading ? '⏳' : '🔎'}
              </button>
              <button onClick={() => del(s.key, rows.filter(x => x.key === s.key).length > 1 ? s.scope : null)} className="text-xs text-gray-300 hover:text-red-600 dark:hover:text-red-300 shrink-0">🗑</button>
            </div>
          ))}
          {rows.filter(s => chk[s.key] && !chk[s.key].loading).map(s => {
            const c = chk[s.key];
            return (
              <div key={s.key + '-chk'} className={`px-3 py-2 text-[11px] ${c.ok ? 'bg-green-50 dark:bg-green-900/30' : c.error ? 'bg-red-50 dark:bg-red-900/30' : 'bg-amber-50 dark:bg-amber-900/30'}`}>
                <div className="font-semibold mb-0.5">{c.ok ? '✅' : c.error ? '❌' : '⚠️'} {s.key}</div>
                <div className="text-gray-700 dark:text-gray-300">{c.error || c.verdict}</div>
                {!!(c.blocked || []).length && (
                  <div className="text-gray-500 dark:text-gray-400 mt-0.5">Yopiq: {c.blocked.map(b => `${b.label} (${b.reason})`).join(', ')}</div>
                )}
                {c.message && <div className="text-gray-700 dark:text-gray-300 mt-1">{c.message}</div>}
                {c.fixable && !c.fixing && !c.needLogin && (
                  <button onClick={() => checkKey(s.key, true)}
                    className="mt-1.5 px-2 py-1 rounded bg-primary-700 dark:bg-primary-600 text-white font-semibold">
                    🛠 Khorezmai o'zi to'g'irlasin
                  </button>
                )}
                {c.needLogin && (
                  <div className="mt-1 text-primary-800 dark:text-primary-300">
                    🔐 Konsollar bo'limida «{c.profileLabel || c.profile}» sessiyasini ochib kiring, keyin
                    <b> 🛠 Khorezmai o'zi to'g'irlasin</b>ni bosing.
                    <button onClick={() => checkKey(s.key, true)} className="ml-2 px-2 py-1 rounded border border-primary-300 dark:border-primary-700">↻ Qayta urinish</button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
      {!rows.length && <div className="text-xs text-gray-400 mb-3">Hali sir qo'shilmagan.</div>}

      {open && (
        <div className="border-2 border-primary-100 dark:border-primary-800 rounded p-3 mb-3">
          <div className="flex flex-wrap gap-2 items-end">
            <label className="text-[11px] text-gray-500 dark:text-gray-400">Env nomi
              <input value={form.key} onChange={e => setForm(f => ({ ...f, key: e.target.value.toUpperCase() }))}
                placeholder="ESKIZ_PASSWORD" className="block mt-0.5 border rounded px-2 py-1 text-sm font-mono w-48" />
            </label>
            <label className="text-[11px] text-gray-500 dark:text-gray-400">Qiymat
              <input type="password" value={form.value} autoComplete="new-password"
                onChange={e => setForm(f => ({ ...f, value: e.target.value }))}
                placeholder="••••••••" className="block mt-0.5 border rounded px-2 py-1 text-sm w-56" />
            </label>
            <label className="text-[11px] text-gray-500 dark:text-gray-400">Qayerga
              <select value={form.scope} onChange={e => setForm(f => ({ ...f, scope: e.target.value }))}
                className="block mt-0.5 border rounded px-2 py-1 text-sm">
                <option value="both">🧪🚀 ikkalasi</option>
                <option value="test">🧪 faqat test</option>
                <option value="prod">🚀 faqat prod</option>
              </select>
            </label>
            <button onClick={save} disabled={busy}
              className="px-3 py-1.5 text-sm bg-primary-700 dark:bg-primary-600 text-white rounded disabled:opacity-50">💾 Saqlash</button>
          </div>
        </div>
      )}

      <div className="flex gap-2 flex-wrap">
        {!open && (
          <button onClick={() => setOpen(true)} className="px-3 py-1.5 text-sm border border-dashed rounded text-gray-600 dark:text-gray-400 hover:border-primary-500">
            ➕ Sir qo'shish
          </button>
        )}
        <button onClick={() => apply('test')} disabled={busy || serverRunning || !rows.length}
          className="px-3 py-1.5 text-sm border rounded disabled:opacity-40">🧪 Test env'ga qo'llash</button>
        <button onClick={() => apply('prod')} disabled={busy || serverRunning || !rows.length || !hasProd}
          title={hasProd ? '' : 'Production server sozlanmagan'}
          className="px-3 py-1.5 text-sm border rounded disabled:opacity-40">🚀 Prod'ga qo'llash</button>
      </div>
    </div>
  );
}
